import React from "react";
import ParticipantDebugInfo from "../Participant/ParticipantDebugInfo";
import CultureFlag from "components/Culture/CultureFlag";
import { ContactSidePanel } from "components/SidePanel/contact/ContactSidePanel";
import { PhosphorPencilButton, PhosphorTrashButton } from "components/Atoms/PhosphorIconButton";
import CollapsibleSection from "components/DetailPage/CollapsibleSection";
import InPageEditableFieldWithLabel from "components/MainSectionTemplate/InPageEditableFieldWithLabel";
import { OptionalTextAreaDetails } from "components/ValidatedFields/OptionalTextAreaInput";
import { isNullOrEmptyString } from "utilities";
import { getLcidFromParticipant } from "utilities/esigningUtils";
import { useContact } from "utilities/hookutils";

interface Props {
  lifeCycle: server.dto.DocumentLifeCycles
  participant: server.dto.ESignParticipant
  onDeleteClicked?: () => void
  onEditClicked?: () => void
}

const ViewerRowCard = (props: Props) => {
  const { participant } = props;

  const canEdit = props.lifeCycle === "draft" || props.lifeCycle === "review";
  const contact = useContact(participant.contact);

  return <div className="flex-column gap">
    <div className="flex gap">
      <div>
        <CultureFlag lcid={getLcidFromParticipant(participant.linkedToUser, contact)} size="medium" />
      </div>
      <div className="grow1 flex-column gap-small">
        <div>
          <ContactSidePanel
            trigger={<h4>
              <a>
                {contact.name.fullName}
              </a>
            </h4>}
            contactId={contact.contactId}
          />
        </div>

        <div>
          {participant.email}
        </div>

        <ParticipantDebugInfo participant={props.participant} />
      </div>
      {canEdit && <>
        {props.onDeleteClicked && <PhosphorTrashButton
          layout="in-square"
          onClick={props.onDeleteClicked} />}
        {props.onEditClicked && <PhosphorPencilButton
          layout="in-square"
          onClick={props.onEditClicked} />}
      </>}
    </div>
    {
      canEdit && <div>
        <CollapsibleSection
          title={RESX.Invitation.resxInvitation}
          collapsible="startClosed"
          uniqueRowId={`esign-viewer-${participant.eSignParticipantId}`}
        >
          <div className="main-section-template-grid">
            <InPageEditableFieldWithLabel
              compact={false}
              field={{
                key: "subject",
                label: "Subject",
                isEmpty: isNullOrEmptyString(participant.invitationSubject),
                render: () => <div>{participant.invitationSubject}</div>
              }}
            />

            <InPageEditableFieldWithLabel
              compact={false}
              field={{
                key: "body",
                label: "Body",
                isEmpty: isNullOrEmptyString(participant.invitationBody),
                render: () => <OptionalTextAreaDetails>{participant.invitationBody}</OptionalTextAreaDetails>
              }}
            />
          </div>
        </CollapsibleSection>
      </div>
    }
  </div>;
};

export default ViewerRowCard;